import { ChevronRight, CircleNotifications } from '@mui/icons-material'
import classNames from 'classnames'
import { useIsAuth } from 'feature/auth/hooks'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Loading } from 'router/Loading'
import { useThunkDispatch } from 'store/hooks'
import { Button } from 'ui'
import { EmptyInformationBlock } from 'widget/EmptyInformationBlock/EmptyInformationBlock'

import { NotificationItem } from './NotificationItem'
import style from './Notifications.module.scss'
import {
  noticeApi,
  useGetNoticeHistoryQuery,
  useMarkAsReadHistoryItemMutation,
} from './redux/noticeApi'

// список уведомлений
export function Notifications() {
  const isAuth = useIsAuth()
  const thunkDispatch = useThunkDispatch()
  const [isSendRequest, setIsSendRequest] = useState(false)
  const { data, isLoading, refetch } = useGetNoticeHistoryQuery(undefined, {
    skip: !isAuth,
  })
  const location = useLocation()
  useEffect(() => {
    if (location.pathname === '/notice') refetch()
  }, [location])

  useEffect(() => {
    return () => {
      thunkDispatch(noticeApi.util.resetApiState())
    }
  }, [])

  const [MarkAsReadHistoryItem] = useMarkAsReadHistoryItemMutation()

  const idsWithIsReadFalse = data?.items
    .filter(item => item.isRead === false)
    .map(item => item.id)
  let timer: ReturnType<typeof setTimeout>
  let ids: number[] = []

  const markNoticeIdsAsReded = (id: number) => {
    if (timer) clearTimeout(timer)

    if (isSendRequest) return
    ids.push(id)
    timer = setTimeout(() => {
      MarkAsReadHistoryItem(ids)
      ids = []
    }, 3000)
  }

  const handleSetNoticeReaded = () => {
    setIsSendRequest(true)
    if (timer) clearTimeout(timer)
    if (idsWithIsReadFalse) {
      MarkAsReadHistoryItem(idsWithIsReadFalse)
    }
  }

  if (isLoading) return <Loading />

  return (
    <section>
      <div className={style.header}>
        <Button
          // @ts-ignore
          to={-1}
          variant='text'
          className={style.backButton}
          color='primary'
          startIcon={
            <ChevronRight
              color='primary'
              className={classNames('rotate180', style.chevronRight)}
            />
          }
        >
          Назад
        </Button>
      </div>
      <span className={classNames('h1', style.title)}>Уведомления</span>

      {!!idsWithIsReadFalse?.length && (
        <Button
          variant='text'
          className={style.checkAllButton}
          onClick={handleSetNoticeReaded}
        >
          Пометить все как прочитанные
        </Button>
      )}

      <div className={style.notificationsList}>
        {data &&
          data.items.map(item => (
            <NotificationItem
              item={item}
              key={item.id}
              markAsReded={markNoticeIdsAsReded}
            />
          ))}
        {data?.items.length === 0 && (
          <div className={style.emptyInformationBlock}>
            <EmptyInformationBlock
              title='Здесь будут ваши уведомления'
              Icon={CircleNotifications}
            />
          </div>
        )}
      </div>
    </section>
  )
}
